import { dismissKeys } from './state';

export default {
	setAnalyticsData(state, payload) {
		this._vm.$set(state, 'analytics', payload);
	},
	setTopCampaigns(state, payload) {
		this._vm.$set(state, 'topCampaigns', payload.slice(0, 5));
	},
	updateDateRange(state, payload) {
		this._vm.$set(state, 'dateRange', payload);
	},
	dismiss(state, { dismissed = true, key }) {
		this._vm.$set(state, `dismissed${key}`, Boolean(dismissed));
	},
	// For manual resetting via browser console.
	resetDismissed(state) {
		dismissKeys.forEach((k) => {
			this._vm.$set(state, k, false);
		});
	},
	setMinDate(state, date) {
		this._vm.$set(state, 'minDate', date);
	},
	setAnnouncements(state, payload) {
		this._vm.$set(state, 'announcements', payload);
	},
};
